<template>
    <div class="row">
        <div class="col-12">
            <div class="form-group">
                <div class="checkbox-container mb-2">
                    <input type="checkbox" name="privacidad" id="privacidad" :class="!privacidad && error ? 'is-invalid' : ''" v-model="privacidad" @change="$emit('clickPrivacidad')">
                    <label for="privacidad">
                        {{ $t('formularios.he_leido') }}
                        <router-link
                            :to="{ name: 'legal' }"
                            target="_blank"
                        >
                            <span>{{ $t('formularios.terminos_condiciones') }}</span>
                        </router-link> 
                        y la 
                        <router-link
                            :to="{ name: 'privacidad' }"
                            target="_blank"
                        >
                            <span>{{ $t('formularios.politica_privacidad') }}</span>
                        </router-link>
                    </label>
                </div>
                <span class="error" v-if="!privacidad && error">{{ $t('formularios.error_terminos') }}</span>
            </div>
            <div class="form-group">
                <div class="checkbox-container mb-2">
                    <input type="checkbox" name="condiciones" id="condiciones" :class="!condiciones && error ? 'is-invalid' : ''" v-model="condiciones" @change="$emit('clickCondiciones')">
                    <label for="condiciones">{{ $t('formularios.acepto_condiciones') }}</label>
                </div>
                <span class="error" v-if="!condiciones && error">{{ $t('formularios.error_condiciones') }}</span>
            </div>
            <div class="form-group">
                <div class="checkbox-container mb-2">
                    <input type="checkbox" name="comunicaciones" id="comunicaciones" :class="!comunicaciones && error ? 'is-invalid' : ''" v-model="comunicaciones" @change="$emit('clickComunicaciones')">
                    <label for="comunicaciones">{{ $t('formularios.acepto_comunicaciones') }}</label>
                </div>
                <span class="error" v-if="!comunicaciones && error">{{ $t('formularios.error_comunicaciones') }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['error'],
        data() {
            return {
                privacidad: false,
                condiciones: false,
                comunicaciones: false
            }
        },

    }
</script>